import { CurrencyPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { convertDateToMaskTimezone } from '@app/shared/utils';
import { DashboardData } from 'viggo-sistemas-core-web';
import { DashboardService } from '../service/dashboard.service';

@Component({
  selector: 'dashboard-info',
  templateUrl: './dashboard-info.component.html',
  styleUrls: ['./dashboard-info.component.scss'],
  providers: [DashboardService, CurrencyPipe]
})
export class DashBoardInfoComponent implements OnInit {
  dashboardData = [] as DashboardData[];

  public keywordFormDateRange = new UntypedFormControl();
  public keywordFormDateRangeStart = new UntypedFormControl();
  public keywordFormDateRangeEnd = new UntypedFormControl();

  maxDate = new Date();
  minDateField = new Date(new Date().setDate(new Date().getDate() - 90));
  minDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

  constructor(
    protected dashboardService: DashboardService,
    public currencyPipe: CurrencyPipe
  ) {}

  public ngOnInit() {
    this.keywordFormDateRange.setValue([this.minDate, this.maxDate]);
    this.keywordFormDateRange.valueChanges.subscribe(value => {
      if (value) {
        if (value[0]) this.keywordFormDateRangeStart.setValue(value[0]);
        if (value[1]) {
          this.keywordFormDateRangeEnd.setValue(value[1]);
          this.onSearch();
        }
      }
    });
    this.onLoad();
  }

  protected onLoad() {
    this.dashboardService.getValuesDashboard().subscribe({
      next: value => {
        this.dashboardData = [];
        Object.keys(value.dashboard).forEach(key => {
          this.dashboardData.push({
            icon: this.getIconAndTitle(key, 'icon'),
            showPopUp: false,
            statistic_data:
              typeof value.dashboard[key] === 'object' &&
              value.dashboard[key] !== null &&
              Object.keys(value.dashboard[key]).length > 0
                ? this.getStatsOfTitle(value.dashboard[key], false)
                : key === 'vendas_receita'
                ? value.dashboard[key]
                  ? this.currencyPipe.transform(value.dashboard[key], 'BRL')
                  : 0
                : value.dashboard[key],
            title: this.getIconAndTitle(key, 'title'),
            subtitle:
              typeof value.dashboard[key] === 'object' &&
              value.dashboard[key] !== null &&
              Object.keys(value.dashboard[key]).length > 0
                ? 'de um total de ' +
                  this.getStatsOfTitle(value.dashboard[key], true)
                : null,
            style: this.getStyle(key),
            statistic_result: null,
            overviewChartData: null,
            overviewChartOptions: null
          });
        });
      }
    });
  }

  getStatsOfTitle(obj, subtitle: boolean) {
    var stats = 0;
    var statsSub = 0;
    Object.keys(obj).forEach(key => {
      if (key.includes('total') && subtitle) statsSub = obj[key];
      if (!key.includes('total')) stats = obj[key];
    });
    return subtitle ? statsSub : stats;
  }

  getStyle(key: string) {
    if (key === 'produto_vendas') {
      return {
        background_color_card: 'white',
        border_style_card: '1px solid var(--primary-color)',
        icon_color: 'var(--primary-color)',
        text_color_card: 'var(--primary-color)',
        title_color: 'var(--primary-color)',
        subtitle_color: 'var(--primary-color)'
      };
    } else if (key === 'vendas_receita') {
      return {
        background_color_card: 'white',
        border_style_card: '1px solid var(--primary-color)',
        icon_color: 'var(--primary-color)',
        text_color_card: 'var(--primary-color)',
        title_color: 'var(--primary-color)',
        subtitle_color: 'var(--primary-color)'
      };
    } else if (key === 'cliente_vendas') {
      return {
        background_color_card: 'white',
        border_style_card: '1px solid var(--primary-color)',
        icon_color: 'var(--primary-color)',
        text_color_card: 'var(--primary-color)',
        title_color: 'var(--primary-color)',
        subtitle_color: 'var(--primary-color)'
      };
    } else if (key === 'produto_cadastro') {
      return {
        background_color_card: 'white',
        border_style_card: '1px solid var(--primary-color)',
        icon_color: 'var(--primary-color)',
        text_color_card: 'var(--primary-color)',
        title_color: 'var(--primary-color)',
        subtitle_color: 'var(--primary-color)'
      };
    } else if (key === 'vendas_total') {
      return {
        background_color_card: 'white',
        border_style_card: '1px solid var(--primary-color)',
        icon_color: 'var(--primary-color)',
        text_color_card: 'var(--primary-color)',
        title_color: 'var(--primary-color)',
        subtitle_color: 'var(--primary-color)'
      };
    } else if (key === 'cliente_cadastro') {
      return {
        background_color_card: 'white',
        border_style_card: '1px solid var(--primary-color)',
        icon_color: 'var(--primary-color)',
        text_color_card: 'var(--primary-color)',
        title_color: 'var(--primary-color)',
        subtitle_color: 'var(--primary-color)'
      };
    }
  }

  getIconAndTitle(key: string, tipo: string) {
    if (key === 'produto_vendas') {
      return tipo === 'title'
        ? 'Produtos vendidos'
        : 'pi pi-fw pi-shopping-cart';
    } else if (key === 'vendas_receita') {
      return tipo === 'title' ? 'Receita gerada' : 'mdi mdi-currency-brl';
    } else if (key === 'cliente_vendas') {
      return tipo === 'title'
        ? 'Vendas por cliente'
        : 'mdi mdi-account-check-outline';
    } else if (key === 'produto_cadastro') {
      return tipo === 'title'
        ? 'Produtos cadastrados'
        : 'mdi mdi-archive-arrow-down-outline';
    } else if (key === 'vendas_total') {
      return tipo === 'title' ? 'Total de vendas' : 'mdi mdi-store-plus';
    } else if (key === 'cliente_cadastro') {
      return tipo === 'title'
        ? 'Clientes cadastrados'
        : 'pi pi-fw pi-user-plus';
    }
  }

  clearFilter() {
    this.keywordFormDateRange.setValue('');
    this.keywordFormDateRangeStart.setValue('');
    this.keywordFormDateRangeEnd.setValue('');
    this.onLoad();
  }

  enterSearch(event) {
    if (event.key === 'Enter') {
      this.onSearch();
    }
  }

  onSearch() {
    var valueDateStart = convertDateToMaskTimezone(
      this.keywordFormDateRangeStart.value
    );
    var valueDateEnd = convertDateToMaskTimezone(
      this.keywordFormDateRangeEnd.value
    );

    this.dashboardService
      .filtrarPorDatas(valueDateStart, valueDateEnd)
      .subscribe({
        next: value => {
          this.dashboardData = [];
          Object.keys(value.dashboard).forEach(key => {
            this.dashboardData.push({
              icon: this.getIconAndTitle(key, 'icon'),
              showPopUp: false,
              statistic_data:
                typeof value.dashboard[key] === 'object' &&
                value.dashboard[key] !== null &&
                Object.keys(value.dashboard[key]).length > 0
                  ? this.getStatsOfTitle(value.dashboard[key], false)
                  : key === 'vendas_receita'
                  ? value.dashboard[key]
                    ? this.currencyPipe.transform(value.dashboard[key], 'BRL')
                    : 0
                  : value.dashboard[key],
              title: this.getIconAndTitle(key, 'title'),
              subtitle:
                typeof value.dashboard[key] === 'object' &&
                value.dashboard[key] !== null &&
                Object.keys(value.dashboard[key]).length > 0
                  ? 'de um total de ' +
                    this.getStatsOfTitle(value.dashboard[key], true)
                  : null,
              style: this.getStyle(key),
              statistic_result: null,
              overviewChartData: null,
              overviewChartOptions: null
            });
          });
        }
      });
  }
}
